var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25413 3.09858C9.01874 1.73928 10.9758 1.73928 11.7404 3.09858L17.3207 13.0191C18.0707 14.3523 17.1072 15.9996 15.5776 15.9996H4.41697C2.88732 15.9996 1.92389 14.3523 2.67382 13.0191L8.25413 3.09858ZM10.9972 12.9998C10.9972 13.552 10.5495 13.9998 9.99719 13.9998C9.44491 13.9998 8.99719 13.552 8.99719 12.9998C8.99719 12.4475 9.44491 11.9998 9.99719 11.9998C10.5495 11.9998 10.9972 12.4475 10.9972 12.9998ZM9.99719 4.99976C9.44491 4.99976 8.99719 5.44747 8.99719 5.99976V8.99976C8.99719 9.55204 9.44491 9.99976 9.99719 9.99976C10.5495 9.99976 10.9972 9.55204 10.9972 8.99976V5.99976C10.9972 5.44747 10.5495 4.99976 9.99719 4.99976Z",
    fill: "#9CA3AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.1f24fb52.svg";
export { ForwardRef as ReactComponent };